import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function ContactRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to homepage
    navigate('/');
    
    // Wait a bit for the page to load, then scroll to contact form
    setTimeout(() => {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 300);
  }, [navigate]);

  return (
    <div className="app">
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h2>Redirection vers le formulaire de contact...</h2>
          <p>Un instant...</p>
        </div>
      </div>
    </div>
  );
}

export default ContactRedirect;
